import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './SrProgressBarPercent.less';

export const SR_PROGRESS_BAR_THEME_YELLOW = 'SR_PROGRESS_BAR_THEME_YELLOW';
export const SR_PROGRESS_BAR_THEME_ROUNDED_YELLOW = 'SR_PROGRESS_BAR_THEME_ROUNDED_YELLOW';
export const SR_PROGRESS_BAR_THEME_ROUNDED_GREEN = 'SR_PROGRESS_BAR_THEME_ROUNDED_GREEN';
export const SR_PROGRESS_BAR_THEME_ROUNDED_BLACK = 'SR_PROGRESS_BAR_THEME_ROUNDED_BLACK';
export const SR_PROGRESS_BAR_THEME_TO_CLASSNAME_MAPPING = {
  [SR_PROGRESS_BAR_THEME_YELLOW]: 'srProgressBarThemeYellow',
  [SR_PROGRESS_BAR_THEME_ROUNDED_YELLOW]: 'srProgressBarThemeRoundedYellow',
  [SR_PROGRESS_BAR_THEME_ROUNDED_GREEN]: 'srProgressBarThemeRoundedGreen',
  [SR_PROGRESS_BAR_THEME_ROUNDED_BLACK]: 'srProgressBarThemeRoundedBlack',
};
export const SR_PROGRESS_BAR_THEMES = Object.keys(SR_PROGRESS_BAR_THEME_TO_CLASSNAME_MAPPING);

const SrProgressBarPercent = ({
  percent,
  withBackground,
  text,
  theme,
  positionFixed,
}) => (
  <div
    className='SrProgressBarPercent'
    styleName={
      classnames(
        'SrProgressBarPercent',
        SR_PROGRESS_BAR_THEME_TO_CLASSNAME_MAPPING[theme],
        {
          hide: (percent < 0 || percent > 100),
          positionFixed,
        }
      )
    }
  >
    {withBackground && (
      <div styleName='background' />
    )}
    <div
      styleName='bar'
      style={{
        width: `${percent < 0 ? 0 : percent}%`,
      }}
    />
    {text && <div styleName='text'>{text}</div>}
  </div>
);

SrProgressBarPercent.propTypes = {
  percent: PropTypes.number.isRequired,
  theme: PropTypes.oneOf(SR_PROGRESS_BAR_THEMES),
  withBackground: PropTypes.bool,
  positionFixed: PropTypes.bool,
};

SrProgressBarPercent.defaultProps = {
  withBackground: false,
};

SrProgressBarPercent.displayName = 'SrProgressBarPercent';

export default SrProgressBarPercent;
